function obterBreadcrumbs() {
  var defaultBreadcrumbs = [];

  defaultBreadcrumbs.push({
    name: 'inicio',
    title: 'Início',
    url: SITEURL
  });

  defaultBreadcrumbs.push({
    name: 'internacionalizacao',
    title: 'Internacionalização',
    url: SITEURL + '/internacionalize-agora'
  });


  defaultBreadcrumbs.push({
    name: 'dashboard-empresa',
    title: 'Dashboard',
    url: APPURL + '#/dashboard/empresa/' + localStorage.getItem('company_id')
  });

  defaultBreadcrumbs.push({
    name: 'dashboard-fiesc',
    title: 'Dashboard',
    url: APPURL + '#/dashboard/empresas/'
  });

  return defaultBreadcrumbs;
}

function construirBreadcrumb(breadcrumbNames) {
  // var defaultBreadcrumbs = obterBreadcrumbs();
  // var retorno = [];
  // breadcrumbNames.forEach(function (name) {
  //   defaultBreadcrumbs.forEach(function (breadcrumbDefault) {
  //     if (breadcrumbDefault.name === name) { retorno.push(breadcrumbDefault); }
  //   });
  // });
  // construirBreadcrumbHtml(retorno);
  // return retorno;
}

function construirBreadcrumbHtml(breadcrumbs) {
  jQuery(function ($) {
    var itens;
    ul = $('#lista-breadcrumb').empty();
    breadcrumbs.forEach(function (breadcrumb) {
      var li = $('<li class="breadcrumb-item"> </li>');
      var a = $('<a href="' + breadcrumb.url + '">' + breadcrumb.title + '</a>')
      li.append(a);
      ul.append(li);
    });
  });
}
